<table>

  <thead>
    <tr>
      <th>Opération</th>
      <th style="width: 130px">Catégorie</th>
      <th style="width: 150px">Dernière révision</th>
      <th style="width: 50px;"></th>
    </tr>
  </thead>

  <tbody *ngIf="operations && operations.length > 0">
    <tr *ngFor="let operation of operations" (click)="onSelect(operation)">
      <td name="Opération">
        {{ operation.name }}
      </td>
      <td name="Catégorie" style="width: 130px">
        {{ operation.category ? operation.category : '-' }}
      </td>
      <td name="Dernière révision" style="width: 150px">
        {{ operation.revisions.length > 0 ? operation.revisions[0].number : '-' }}
      </td>
      <td style="width: 50px;" class="actions">
        <a class="action-btn">
          <t-icon name="arrow_forward"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!operations || operations.length == 0">
    <tr>
      <td class="text-center" colspan="4">
        <ng-container *ngIf="operations && operations.length == 0">
          Aucune opération n'a été trouvée
        </ng-container>
        <ng-container *ngIf="!operations">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>

<div class="pagination" *ngIf="operations">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="operations.length < operationsCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ operations.length }} / {{ operationsCount }}
  </div>
</div>